<!--横向滑动推荐历史新闻类  view:7-->
<template>
    <div class="view8Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl?item.imgUrl:`https://dcdn.thecover.cn/cgbc/${imageArray[random]}.jpg`" :name="item.title" :year="item.year"  @on-click="()=>onRouter(item.linkUrl,item.newsId,item.newsKind,item.title,item.content,item.source,item.datePublish,item.videoUrl,item.imgUrl)" :key="`tips-quick-${ix}`" card-type="old" />
        </CrossSlip>
    </div>
</template>


<script>
    import CrossSlip from '../Use/cross-slip-wrapper'
    import BaseCard from '../Use/base-card'
    import {mapState, mapActions, mapMutations} from "vuex";
    import {RandomNumBoth} from "@/utils/utils";
    export default {
        name: 'View8',
        components: {
            CrossSlip,BaseCard
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
        },
        data () {
            return {
                random:RandomNumBoth(0,2),
                imageArray:['oldToday1','oldToday2','oldToday3']
            }
        },
        methods: {
            ...mapMutations(["setNewsContent"]),
            onRouter(path, id, newsKind, name, content, source, datePublish, videoUrl, imgUrl) {
                this.setNewsContent({newsTitle: name, content, source, datePublish, newsKind:11, path, videoUrl, imgUrl});
                this.$emit("on-show",id,{newsTitle: name, content, source, datePublish, newsKind:11, path, videoUrl, imgUrl},8);
            },
        }
    }
</script>
<style lang="less" scoped>
    .view8Wrapper{

    }

</style>
